var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-page',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"description":_vm.description,"button-text":_vm.buttonText,"secondary-button-text":_vm.secondaryButtonText,"secondary-button-href":"https://t.me/LantonPaykefu","bg":_vm.bg}})
}
var staticRenderFns = []

export { render, staticRenderFns }